import React from 'react';
import { CheckCircle, XCircle, AlertCircle } from 'lucide-react';

interface ApprovalStatusBadgeProps {
  status: 'pending' | 'approved' | 'refused';
  size?: 'sm' | 'md' | 'lg';
  showIcon?: boolean;
}

const ApprovalStatusBadge: React.FC<ApprovalStatusBadgeProps> = ({ 
  status, 
  size = 'md', 
  showIcon = true 
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'approved':
        return {
          text: 'Approuvé',
          icon: CheckCircle,
          className: 'text-green-600 bg-green-50 border-green-200',
          iconClassName: 'text-green-600'
        };
      case 'refused':
        return {
          text: 'Rejeté',
          icon: XCircle,
          className: 'text-red-600 bg-red-50 border-red-200',
          iconClassName: 'text-red-600'
        };
      case 'pending':
      default:
        return {
          text: 'En attente',
          icon: AlertCircle,
          className: 'text-brand-accent bg-brand-accent/10 border-brand-accent/20',
          iconClassName: 'text-brand-accent'
        };
    }
  };

  const config = getStatusConfig();
  const IconComponent = config.icon;

  const sizeClasses = {
    sm: 'px-2 py-1 text-xs',
    md: 'px-3 py-1.5 text-sm',
    lg: 'px-4 py-2 text-base'
  };

  const iconSizes = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  return (
    <div className={`inline-flex items-center gap-1.5 rounded-full border font-medium ${config.className} ${sizeClasses[size]}`}>
      {showIcon && (
        <IconComponent className={`${iconSizes[size]} ${config.iconClassName}`} />
      )}
      <span>{config.text}</span>
    </div>
  );
};

export default ApprovalStatusBadge;
